import { Loader2 } from 'lucide-react'

import { useMainStore } from '../stores/main.store'
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogTitle } from './ui/alert-dialog'

export function ModalLoadingComponent() {
	const { isLoading, loadingMessage, progress } = useMainStore()

	return (
		<AlertDialog open={isLoading}>
			<AlertDialogContent className="flex flex-col items-center flex-1 top-[95%] m-0 pb-28 md:pb-40 md:pt-10 lg:p-8 w-screen max-w-full lg:max-w-lg mb-2 lg:top-[50%] rounded-t-2xl">
				<AlertDialogTitle className='hidden'>Carregando</AlertDialogTitle>
				<Loader2 className="animate-spin text-primary size-10 text-center" />
				<AlertDialogDescription className="text-center">
					{loadingMessage}
				</AlertDialogDescription>

				{/* Barra de progresso - só aparece quando há progresso para mostrar */}
				{progress.total > 0 && (
					<div className="w-full mt-4 space-y-2">
						<div className="flex justify-between text-sm text-muted-foreground">
							<span>Processando produtos...</span>
							<span>{progress.current} de {progress.total} produtos</span>
						</div>

						{/* Barra de progresso */}
						<div className="w-full bg-secondary rounded-full h-2">
							<div
								className="bg-primary h-2 rounded-full transition-all duration-300 ease-in-out"
								style={{ width: `${progress.percentage}%` }}
							/>
						</div>

						<div className="text-center text-sm font-medium">
							{progress.percentage}%
						</div>
					</div>
				)}
			</AlertDialogContent>
		</AlertDialog>
	)
}